"use strict";
/**
 * @fileoverview gRPC-Web generated client stub for loopup.ctgateway.v3
 * @enhanceable
 * @public
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SipTrunkAPIClient = void 0;
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck
var grpcWeb = require("grpc-web");
var v3_sip_trunk_api_pb = require("../v3/sip_trunk_api_pb");
var SipTrunkAPIClient = /** @class */ (function () {
    function SipTrunkAPIClient(hostname, credentials, options) {
        this.methodInfoCreateSipTrunkAsync = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v3.SipTrunkAPI/CreateSipTrunkAsync', grpcWeb.MethodType.UNARY, v3_sip_trunk_api_pb.CreateSipTrunkAsyncRequest, v3_sip_trunk_api_pb.CreateSipTrunkAsyncResponse, function (request) {
            return request.serializeBinary();
        }, v3_sip_trunk_api_pb.CreateSipTrunkAsyncResponse.deserializeBinary);
        this.methodInfoAddNumberToSipTrunkAsync = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v3.SipTrunkAPI/AddNumberToSipTrunkAsync', grpcWeb.MethodType.UNARY, v3_sip_trunk_api_pb.AddNumberToSipTrunkAsyncRequest, v3_sip_trunk_api_pb.AddNumberToSipTrunkAsyncResponse, function (request) {
            return request.serializeBinary();
        }, v3_sip_trunk_api_pb.AddNumberToSipTrunkAsyncResponse.deserializeBinary);
        this.methodInfoDeleteNumberFromSipTrunkAsync = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v3.SipTrunkAPI/DeleteNumberFromSipTrunkAsync', grpcWeb.MethodType.UNARY, v3_sip_trunk_api_pb.DeleteNumberFromSipTrunkAsyncRequest, v3_sip_trunk_api_pb.DeleteNumberFromSipTrunkAsyncResponse, function (request) {
            return request.serializeBinary();
        }, v3_sip_trunk_api_pb.DeleteNumberFromSipTrunkAsyncResponse.deserializeBinary);
        this.methodInfoCreateSipEndpointAsync = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v3.SipTrunkAPI/CreateSipEndpointAsync', grpcWeb.MethodType.UNARY, v3_sip_trunk_api_pb.CreateSipEndpointAsyncRequest, v3_sip_trunk_api_pb.CreateSipEndpointAsyncResponse, function (request) {
            return request.serializeBinary();
        }, v3_sip_trunk_api_pb.CreateSipEndpointAsyncResponse.deserializeBinary);
        this.methodInfoUpdateSipEndpointsAsync = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v3.SipTrunkAPI/UpdateSipEndpointsAsync', grpcWeb.MethodType.UNARY, v3_sip_trunk_api_pb.UpdateSipEndpointsAsyncRequest, v3_sip_trunk_api_pb.UpdateSipEndpointsAsyncResponse, function (request) {
            return request.serializeBinary();
        }, v3_sip_trunk_api_pb.UpdateSipEndpointsAsyncResponse.deserializeBinary);
        this.methodInfoDeleteSipEndpointAsync = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v3.SipTrunkAPI/DeleteSipEndpointAsync', grpcWeb.MethodType.UNARY, v3_sip_trunk_api_pb.DeleteSipEndpointAsyncRequest, v3_sip_trunk_api_pb.DeleteSipEndpointAsyncResponse, function (request) {
            return request.serializeBinary();
        }, v3_sip_trunk_api_pb.DeleteSipEndpointAsyncResponse.deserializeBinary);
        this.methodInfoDeleteSipTrunkAsync = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v3.SipTrunkAPI/DeleteSipTrunkAsync', grpcWeb.MethodType.UNARY, v3_sip_trunk_api_pb.DeleteSipTrunkAsyncRequest, v3_sip_trunk_api_pb.DeleteSipTrunkAsyncResponse, function (request) {
            return request.serializeBinary();
        }, v3_sip_trunk_api_pb.DeleteSipTrunkAsyncResponse.deserializeBinary);
        this.methodInfoCreateSipTrunkWithEndpointsAsync = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v3.SipTrunkAPI/CreateSipTrunkWithEndpointsAsync', grpcWeb.MethodType.UNARY, v3_sip_trunk_api_pb.CreateSipTrunkWithEndpointsAsyncRequest, v3_sip_trunk_api_pb.CreateSipTrunkWithEndpointsAsyncResponse, function (request) {
            return request.serializeBinary();
        }, v3_sip_trunk_api_pb.CreateSipTrunkWithEndpointsAsyncResponse.deserializeBinary);
        this.methodInfoUpdateSipTrunkWithEndpointsAsync = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v3.SipTrunkAPI/UpdateSipTrunkWithEndpointsAsync', grpcWeb.MethodType.UNARY, v3_sip_trunk_api_pb.UpdateSipTrunkWithEndpointsAsyncRequest, v3_sip_trunk_api_pb.UpdateSipTrunkWithEndpointsAsyncResponse, function (request) {
            return request.serializeBinary();
        }, v3_sip_trunk_api_pb.UpdateSipTrunkWithEndpointsAsyncResponse.deserializeBinary);
        this.methodInfoGetSipTrunkByCustomer = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v3.SipTrunkAPI/GetSipTrunkByCustomer', grpcWeb.MethodType.UNARY, v3_sip_trunk_api_pb.GetSipTrunkByCustomerRequest, v3_sip_trunk_api_pb.GetSipTrunkByCustomerResponse, function (request) {
            return request.serializeBinary();
        }, v3_sip_trunk_api_pb.GetSipTrunkByCustomerResponse.deserializeBinary);
        this.methodInfoSetTrafficDistributionMethodAsync = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v3.SipTrunkAPI/SetTrafficDistributionMethodAsync', grpcWeb.MethodType.UNARY, v3_sip_trunk_api_pb.SetTrafficDistributionMethodAsyncRequest, v3_sip_trunk_api_pb.SetTrafficDistributionMethodAsyncResponse, function (request) {
            return request.serializeBinary();
        }, v3_sip_trunk_api_pb.SetTrafficDistributionMethodAsyncResponse.deserializeBinary);
        if (!options)
            options = {};
        if (!credentials)
            credentials = {};
        options['format'] = 'text';
        this.client_ = new grpcWeb.GrpcWebClientBase(options);
        this.hostname_ = hostname;
        this.credentials_ = credentials;
        this.options_ = options;
    }
    SipTrunkAPIClient.prototype.createSipTrunkAsync = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v3.SipTrunkAPI/CreateSipTrunkAsync', request, metadata || {}, this.methodInfoCreateSipTrunkAsync, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v3.SipTrunkAPI/CreateSipTrunkAsync', request, metadata || {}, this.methodInfoCreateSipTrunkAsync);
    };
    SipTrunkAPIClient.prototype.addNumberToSipTrunkAsync = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v3.SipTrunkAPI/AddNumberToSipTrunkAsync', request, metadata || {}, this.methodInfoAddNumberToSipTrunkAsync, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v3.SipTrunkAPI/AddNumberToSipTrunkAsync', request, metadata || {}, this.methodInfoAddNumberToSipTrunkAsync);
    };
    SipTrunkAPIClient.prototype.deleteNumberFromSipTrunkAsync = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v3.SipTrunkAPI/DeleteNumberFromSipTrunkAsync', request, metadata || {}, this.methodInfoDeleteNumberFromSipTrunkAsync, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v3.SipTrunkAPI/DeleteNumberFromSipTrunkAsync', request, metadata || {}, this.methodInfoDeleteNumberFromSipTrunkAsync);
    };
    SipTrunkAPIClient.prototype.createSipEndpointAsync = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v3.SipTrunkAPI/CreateSipEndpointAsync', request, metadata || {}, this.methodInfoCreateSipEndpointAsync, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v3.SipTrunkAPI/CreateSipEndpointAsync', request, metadata || {}, this.methodInfoCreateSipEndpointAsync);
    };
    SipTrunkAPIClient.prototype.updateSipEndpointsAsync = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v3.SipTrunkAPI/UpdateSipEndpointsAsync', request, metadata || {}, this.methodInfoUpdateSipEndpointsAsync, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v3.SipTrunkAPI/UpdateSipEndpointsAsync', request, metadata || {}, this.methodInfoUpdateSipEndpointsAsync);
    };
    SipTrunkAPIClient.prototype.deleteSipEndpointAsync = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v3.SipTrunkAPI/DeleteSipEndpointAsync', request, metadata || {}, this.methodInfoDeleteSipEndpointAsync, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v3.SipTrunkAPI/DeleteSipEndpointAsync', request, metadata || {}, this.methodInfoDeleteSipEndpointAsync);
    };
    SipTrunkAPIClient.prototype.deleteSipTrunkAsync = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v3.SipTrunkAPI/DeleteSipTrunkAsync', request, metadata || {}, this.methodInfoDeleteSipTrunkAsync, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v3.SipTrunkAPI/DeleteSipTrunkAsync', request, metadata || {}, this.methodInfoDeleteSipTrunkAsync);
    };
    SipTrunkAPIClient.prototype.createSipTrunkWithEndpointsAsync = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v3.SipTrunkAPI/CreateSipTrunkWithEndpointsAsync', request, metadata || {}, this.methodInfoCreateSipTrunkWithEndpointsAsync, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v3.SipTrunkAPI/CreateSipTrunkWithEndpointsAsync', request, metadata || {}, this.methodInfoCreateSipTrunkWithEndpointsAsync);
    };
    SipTrunkAPIClient.prototype.updateSipTrunkWithEndpointsAsync = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v3.SipTrunkAPI/UpdateSipTrunkWithEndpointsAsync', request, metadata || {}, this.methodInfoUpdateSipTrunkWithEndpointsAsync, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v3.SipTrunkAPI/UpdateSipTrunkWithEndpointsAsync', request, metadata || {}, this.methodInfoUpdateSipTrunkWithEndpointsAsync);
    };
    SipTrunkAPIClient.prototype.getSipTrunkByCustomer = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v3.SipTrunkAPI/GetSipTrunkByCustomer', request, metadata || {}, this.methodInfoGetSipTrunkByCustomer, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v3.SipTrunkAPI/GetSipTrunkByCustomer', request, metadata || {}, this.methodInfoGetSipTrunkByCustomer);
    };
    SipTrunkAPIClient.prototype.setTrafficDistributionMethodAsync = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v3.SipTrunkAPI/SetTrafficDistributionMethodAsync', request, metadata || {}, this.methodInfoSetTrafficDistributionMethodAsync, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v3.SipTrunkAPI/SetTrafficDistributionMethodAsync', request, metadata || {}, this.methodInfoSetTrafficDistributionMethodAsync);
    };
    return SipTrunkAPIClient;
}());
exports.SipTrunkAPIClient = SipTrunkAPIClient;
